import { Flex, Space, Typography } from 'antd';

import VideoPlayer from '@/components/ui/video-player';
import { resolveAssetUrl } from '@/pages/drama-review/utils';
import { formatBookTitle, formatDisplayId } from '@/pages/ugc-reports/utils';

type Props = {
    title?: string;
    id?: string | null;
    cover?: string;
    videoUrl?: string;
    withBookTitle?: boolean;
};

const MediaTitleIdCell: React.FC<Props> = ({
    title,
    id,
    cover,
    videoUrl,
    withBookTitle = true,
}) => {
    const displayTitle = withBookTitle ? formatBookTitle(title) : title?.trim() || '-';
    const displayId = id ? formatDisplayId(id) : '-';

    return (
        <Flex align="center" gap={12}>
            {videoUrl ? (
                <VideoPlayer
                    src={resolveAssetUrl(videoUrl)}
                    cover={cover ? resolveAssetUrl(cover) : undefined}
                />
            ) : cover ? (
                <img
                    src={resolveAssetUrl(cover)}
                    alt=""
                    width={48}
                    height={64}
                    style={{ objectFit: 'cover', flexShrink: 0 }}
                />
            ) : (
                <div style={{ width: 48, flexShrink: 0 }} />
            )}
            <Space direction="vertical" size={4} style={{ minWidth: 0 }}>
                <Typography.Text strong style={{ wordBreak: 'break-word' }}>
                    {displayTitle}
                </Typography.Text>
                {id ? (
                    <Typography.Text copyable={{ text: id }} type="secondary" style={{ fontSize: 12 }}>
                        {displayId}
                    </Typography.Text>
                ) : (
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                        -
                    </Typography.Text>
                )}
            </Space>
        </Flex>
    );
};

export default MediaTitleIdCell;
